import React, { useCallback, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { authDev } from "../../firebase";
import { voiceConsoleUrl } from "../../globalVariables";

const TOKEN_MESSAGE = "voice-console-token";
const NEED_TOKEN_MESSAGE = "voice-console-need-token";
const ORGANIZATION_MESSAGE = "voice-console-organization";

const consoleOrigin = () => new URL(voiceConsoleUrl).origin;

export default function VoiceConsolePage({ onReady, path = "" }) {
  const frameRef = useRef(null);
  const location = useLocation();
  const organizationId = location.state?.organizationId || "";
  const frameUrl = `${voiceConsoleUrl}${path}`;

  const sendToken = useCallback(async () => {
    const frame = frameRef.current;
    const user = authDev?.currentUser || getAuth()?.currentUser;
    if (!frame || !frame.contentWindow || !user) return;
    try {
      const idToken = await user.getIdToken();
      frame.contentWindow.postMessage({ type: TOKEN_MESSAGE, idToken }, consoleOrigin());
      if (organizationId) {
        frame.contentWindow.postMessage(
          { type: ORGANIZATION_MESSAGE, organizationId },
          consoleOrigin(),
        );
      }
    } catch (error) {
      console.warn("Voice console: could not get a sign-in token", error);
    }
  }, [organizationId]);

  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== consoleOrigin()) return;
      if (event.data && event.data.type === NEED_TOKEN_MESSAGE) sendToken();
    };
    window.addEventListener("message", onMessage);
    onReady?.();
    return () => window.removeEventListener("message", onMessage);
  }, [onReady, sendToken]);

  return (
    <div
      className="container-fluid VoiceConsolePageContainer d-flex flex-column"
      style={{ height: "calc(100vh - 20px)", paddingTop: 12, paddingBottom: 12 }}
    >
      <div
        style={{
          padding: "0 0 10px",
          borderBottom: "1px solid #e5e7eb",
          marginBottom: 10,
          fontSize: 13,
          color: "#667085",
        }}
      >
        <strong style={{ color: "#28303f" }}>
          {path === "/library" ? "Voice library" : "Voice agent editor"}
        </strong>{" "}
        {path === "/library"
          ? "— every voice the assistant can use, with a preview. “Use” selects it in the editor."
          : "— design the assistant for an organization, test it with a web or phone call, and publish. Reads dev loans; test calls go only to the person testing. Browser calls ask for microphone access."}
      </div>
      <iframe
        ref={frameRef}
        title="Voice agent test console"
        src={frameUrl}
        onLoad={sendToken}
        allow="microphone; autoplay"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        style={{
          flex: 1,
          width: "100%",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          background: "#f7f8fc",
          display: "block",
        }}
      />
    </div>
  );
}
